import React, { Component } from 'react';
import './BackToTop.css'
import { Space } from 'react-zoomable-ui';

class Zoom extends Component {
    render() {
        return (
            <Space>
                {this.props.children}
            </Space>
        );
    }
}

export default Zoom;
